/**
* 支付成功页面
*/
<template>
	<el-result icon="error"  :title="$t('language000090')"  >
		
	</el-result>
</template>

<script>
	export default {
		mounted() {
			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			//alert(userLanguage);
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			// 如果语言受支持，则设置为用户语言，否则设置为默认语言
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;
		},
	}
</script>

<style>
</style>